/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Resource_Allocations_CapacityInputs */

const en_admin_resources_resource_allocations_capacity = /** @type {(inputs: Admin_Resources_Resource_Allocations_CapacityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capacity`)
};

const de_admin_resources_resource_allocations_capacity = /** @type {(inputs: Admin_Resources_Resource_Allocations_CapacityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapazität`)
};

const es_admin_resources_resource_allocations_capacity = /** @type {(inputs: Admin_Resources_Resource_Allocations_CapacityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capacidad`)
};

const fr_admin_resources_resource_allocations_capacity = /** @type {(inputs: Admin_Resources_Resource_Allocations_CapacityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capacité`)
};

const nl_admin_resources_resource_allocations_capacity = /** @type {(inputs: Admin_Resources_Resource_Allocations_CapacityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capaciteit`)
};

/** @type {(inputs: Admin_Resources_Resource_Allocations_CapacityInputs) => LocalizedString} */
const it_admin_resources_resource_allocations_capacity = en_admin_resources_resource_allocations_capacity;

/** @type {(inputs: Admin_Resources_Resource_Allocations_CapacityInputs) => LocalizedString} */
const pt_br2_admin_resources_resource_allocations_capacity = en_admin_resources_resource_allocations_capacity;

/** @type {(inputs: Admin_Resources_Resource_Allocations_CapacityInputs) => LocalizedString} */
const pl_admin_resources_resource_allocations_capacity = en_admin_resources_resource_allocations_capacity;

/** @type {(inputs: Admin_Resources_Resource_Allocations_CapacityInputs) => LocalizedString} */
const hu_admin_resources_resource_allocations_capacity = en_admin_resources_resource_allocations_capacity;

/** @type {(inputs: Admin_Resources_Resource_Allocations_CapacityInputs) => LocalizedString} */
const ro_admin_resources_resource_allocations_capacity = en_admin_resources_resource_allocations_capacity;

/**
* | output |
* | --- |
* | "Capacity" |
*
* @param {Admin_Resources_Resource_Allocations_CapacityInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_resource_allocations_capacity = /** @type {((inputs?: Admin_Resources_Resource_Allocations_CapacityInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Resource_Allocations_CapacityInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_resource_allocations_capacity(inputs)
	if (locale === "de") return de_admin_resources_resource_allocations_capacity(inputs)
	if (locale === "es") return es_admin_resources_resource_allocations_capacity(inputs)
	if (locale === "fr") return fr_admin_resources_resource_allocations_capacity(inputs)
	if (locale === "nl") return nl_admin_resources_resource_allocations_capacity(inputs)
	if (locale === "it") return it_admin_resources_resource_allocations_capacity(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_resource_allocations_capacity(inputs)
	if (locale === "pl") return pl_admin_resources_resource_allocations_capacity(inputs)
	if (locale === "hu") return hu_admin_resources_resource_allocations_capacity(inputs)
	return ro_admin_resources_resource_allocations_capacity(inputs)
});
export { admin_resources_resource_allocations_capacity as "admin.resources.resource_allocations.capacity" }